export function handleCall(
    phoneNumberFormatted: string,
    // E164 value of the phone number
    phoneNumberRaw: string,
    phoneCallerType: string,
    entityId: string,
    anchorElementId: string
): void {
    if (phoneCallerType === 'ringcentral') {
        window.location.href = `tel:${phoneNumberRaw}`;
    } else if (phoneCallerType === 'dialpad') {
        window.location.href = `dialpad://${phoneNumberRaw}`;
        // @ts-expect-error
    } else if (phoneCallerType === 'aircall' && window.dialAircall) {
        // @ts-expect-error
        window.dialAircall(phoneNumberRaw);
    } else if (
        phoneNumberFormatted &&
        (phoneCallerType === 'clicktocall' || phoneCallerType === 'phone')
    ) {
        $(window).trigger(Peep.events.showReactClickToCallPopover, {
            entityId: entityId,
            anchorElementId: anchorElementId,
            rawPhoneNumber: phoneNumberRaw,
            formattedPhoneNumber: phoneNumberFormatted,
        });
    } else if (phoneCallerType === 'skype') {
        window.location.href = `skype:${phoneNumberRaw}?call`;
    }
}
